export class Semaine {
	jours: Date[] = [];

	constructor(jours: Date[]) {
		this.jours = jours;
	}
}
